<arm-dialog (onCancel)="close()"
            (onSubmit)="gotIt()"
            [cancelButtonName]="'Close'"
            [confirmButtonName]="'Got it!'"
            [title]="'Information'">
  <div mat-dialog-content class="content">
    {{data?.message}}
  </div>
</arm-dialog>
